import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import LoginPage from './pages/login';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UnauthenticatedWrapper } from './service/UnauthenticatedWrapper';
import { AuthenticatedWrapper } from './service/AuthenticatedWrapper';
import ForgotPassword from './pages/forgotPassword';
import { route } from './service/router';
import VerifyOtp from './pages/verifyOtp';
import SetPassword from './pages/setPassword';
import ForgotPasswordSuccess from './pages/forgotSuccess';
import NewPassword from './pages/newPassword';
import NotFoundPage from './pages/notFound';
import InvalidLink from './pages/invalidLink';
import UserManagement from './pages/userManagement/userManagement';
import { UserType } from '@inplay/models';
import { ConditionalTermsWrapper } from './service/ConditionTermsWrapper';
import Onboarding from './pages/onboarding';
import Layout from './component/layout/layout';
import VenueSetup from './pages/onboarding/venuSetup/venuSetup';
import Dashboard from './pages/dashboard/dashboard';
import Profile from './pages/profile/profile';
import Sweeps from './pages/sweeps/sweeps';
import { HarmReports } from './pages/harmReports';
import { InterventionReports } from './pages/interventionReports';
import { DeletedHarmReports } from './pages/deletedHarmReports';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route
          path={route.login}
          element={
            <UnauthenticatedWrapper>
              <LoginPage />
            </UnauthenticatedWrapper>
          }
        />
        <Route
          path={route.setPassword}
          element={
            <UnauthenticatedWrapper>
              <SetPassword />
            </UnauthenticatedWrapper>
          }
        />
        <Route
          path={route.invalidLinkPage}
          element={
            <UnauthenticatedWrapper>
              <InvalidLink />
            </UnauthenticatedWrapper>
          }
        />
        <Route
          path={route.newPassword}
          element={
            <UnauthenticatedWrapper>
              <NewPassword />
            </UnauthenticatedWrapper>
          }
        />
        <Route
          path={route.forgotPassword}
          element={
            <UnauthenticatedWrapper>
              <ForgotPassword />
            </UnauthenticatedWrapper>
          }
        />
        <Route
          path={route.forgotPasswordSuccess}
          element={
            <UnauthenticatedWrapper>
              <ForgotPasswordSuccess />
            </UnauthenticatedWrapper>
          }
        />
        <Route
          path={route.verifyOtp}
          element={
            <UnauthenticatedWrapper>
              <VerifyOtp />
            </UnauthenticatedWrapper>
          }
        />
        <Route
          path={route.onboarding}
          element={
            <AuthenticatedWrapper>
              <ConditionalTermsWrapper>
                <Onboarding />
              </ConditionalTermsWrapper>
            </AuthenticatedWrapper>
          }
        />
        <Route
          path={route.venueSetup}
          element={
            <AuthenticatedWrapper>
              <VenueSetup />
            </AuthenticatedWrapper>
          }
        />
        <Route
          path={route.dashboard}
          element={
            <AuthenticatedWrapper>
              <ConditionalTermsWrapper>
                <Layout>
                  <Dashboard />
                </Layout>
              </ConditionalTermsWrapper>
            </AuthenticatedWrapper>
          }
        />
        <Route
          path={route.userManagement}
          element={
            <AuthenticatedWrapper
              restrictedToUserTypes={[
                UserType.VENUE_STAFF,
                UserType.VENUE_BRANCH_LOGIN,
              ]}
            >
              <ConditionalTermsWrapper>
                <Layout>
                  <UserManagement />
                </Layout>
              </ConditionalTermsWrapper>
            </AuthenticatedWrapper>
          }
        />
        <Route
          path={route.profile}
          element={
            <AuthenticatedWrapper>
              <ConditionalTermsWrapper>
                <Layout>
                  <Profile />
                </Layout>
              </ConditionalTermsWrapper>
            </AuthenticatedWrapper>
          }
        />
        <Route
          path={route.sweeps}
          element={
            <AuthenticatedWrapper>
              <ConditionalTermsWrapper>
                <Layout>
                  <Sweeps />
                </Layout>
              </ConditionalTermsWrapper>
            </AuthenticatedWrapper>
          }
        />
        <Route
          path={route.harmReports}
          element={
            <AuthenticatedWrapper>
              <ConditionalTermsWrapper>
                <Layout>
                  <HarmReports />
                </Layout>
              </ConditionalTermsWrapper>
            </AuthenticatedWrapper>
          }
        />
        <Route
          path={route.deletedHarmReports}
          element={
            <AuthenticatedWrapper>
              <ConditionalTermsWrapper>
                <DeletedHarmReports />
              </ConditionalTermsWrapper>
            </AuthenticatedWrapper>
          }
        />
        <Route
          path={route.interventionReports}
          element={
            <AuthenticatedWrapper>
              <ConditionalTermsWrapper>
                <Layout>
                  <InterventionReports />
                </Layout>
              </ConditionalTermsWrapper>
            </AuthenticatedWrapper>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <ToastContainer />
    </Router>
  );
};

export default App;
